export const getMainLayoutStyles = (isOpen: boolean) => ({
  overflow: isOpen ? 'hidden' : 'auto',
});